import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

const Modal = (props) => {
  const { isOpen, onRequestClose } = props;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          zIndex: 1,
          backdropFilter: "blur(2px)",
          backgroundColor: "rgba(13, 19, 31, 0.6)",
          ...props.overlay,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "600px",
          height: "435px",
          borderRadius: "5px",
          padding: 0,
          backgroundColor: "#4b505f",
          border: "none",
          overflow: "none",
          ...props.content,
        },
      }}
    >
      {props.children}
    </ReactModal>
  );
};

export default Modal;
